export default "__VITE_PUBLIC_ASSET__f9b475c1__"